import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@mui/material';
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  arrowButton: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    background: '#fff',
    border: '1px solid black',
    cursor: 'pointer',
    padding: '1rem 0.5rem',
    zIndex: 2,
    transition: 'background-color 0.3s',
    borderRadius: '0',
    display: 'none',
    alignItems: 'center', // Centra el contenido verticalmente
    justifyContent: 'center', // Centra el contenido horizontalmente
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  leftArrow: {
    left: '-2.8rem',
  },
  rightArrow: {
    right: '-2.8rem',
  },
  arrowButtonVisible: {
    display: 'flex',
  },
}));

const ScrollButtons = ({ scrollRef, isOverflowing }) => {
  const classes = useStyles();
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const scrollLeft = scrollRef.current.scrollLeft;
      const maxScrollLeft = scrollRef.current.scrollWidth - scrollRef.current.clientWidth;

      setShowLeftArrow(scrollLeft > 0);
      setShowRightArrow(scrollLeft < maxScrollLeft);
    };
    const scrollElement = scrollRef.current;

    handleScroll();
    scrollElement.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);

    return () => {
      scrollElement.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, [scrollRef, isOverflowing]);

  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -300, behavior: 'smooth' });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 300, behavior: 'smooth' });
  };

  return (
    <>
      {isOverflowing && showLeftArrow && (
        <IconButton
          className={`${classes.arrowButton} ${classes.leftArrow} ${classes.arrowButtonVisible}`}
          onClick={scrollLeft}
        >
          <ArrowBackIos />
        </IconButton>
      )}
      {isOverflowing && showRightArrow && (
        <IconButton
          className={`${classes.arrowButton} ${classes.rightArrow} ${classes.arrowButtonVisible}`}
          onClick={scrollRight}
        >
          <ArrowForwardIos />
        </IconButton>
      )}
    </>
  );
};

ScrollButtons.propTypes = {
  scrollRef: PropTypes.shape({
    current: PropTypes.any,
  }).isRequired,
  isOverflowing: PropTypes.bool.isRequired,
};

export default ScrollButtons;
